import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=20e6e20e"
import script from "./PurchaseCard.vue?vue&type=script&lang=ts"
export * from "./PurchaseCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports